import React, { useEffect, useState } from "react";
import Input from "./InputYeni";
import Button from "./Button";
import { useLocation, useNavigate } from "react-router-dom";
import YesilAlert from "../projeler/YesilAlert";
import { useDispatch, useSelector } from "react-redux";
import { yeniSifreRequest } from "../../redux/actions/sifremiUnuttumAction";
import { setShowAlert, setError } from "../../redux/slices/sifremiUnuttumSlice";

const YeniSifre = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [tokenState, setTokenState] = useState(null);
  const { loading, error, alertMessage, showAlert } = useSelector(
    (state) => state.sifremiUnuttum
  );

  const email = location.state?.email || "";

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token");
    if (token) {
      setTokenState(token);
    }
  }, [location.search]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const newPassword = formData.get("password");

    if (!tokenState) {
      dispatch(
        setError("Geçersiz şifre sıfırlama linki. Lütfen tekrar deneyiniz.")
      );
      return;
    }

    if (!newPassword || newPassword.length < 8) {
      dispatch(
        setError(
          "Şifre en az 8 karakter, bir büyük harf ve bir rakam içermelidir."
        )
      );
      return;
    }

    dispatch(yeniSifreRequest(tokenState, newPassword));
  };

  const handleAlertConfirm = () => {
    dispatch(setShowAlert(false));
  };

  const handleAlertClose = () => {
    dispatch(setShowAlert(false));
    navigate("/giris_yap");
  };

  return (
    <div className="containerMain grid grid-cols-1 mx-auto place-items-center h-auto">
      <form
        className="form-container flex flex-col gap-8"
        onSubmit={handleSubmit}
      >
        <div className="w-[80%] grid place-items-center my-3 ">
          <img src="/logo.svg" alt="logo" className="w-full border-b-2 pb-5" />
        </div>
        <div className="flex flex-col gap-4">
          <p className="text-xl font-medium text-dark text-center">
            Yeni şifre belirle
          </p>
          <p className="text-base font-normal text-grayy text-center max-w-[376px]">
            Hesabınıza yeniden erişim sağlamak için lütfen yeni şifrenizi
            belirleyin.
          </p>
        </div>
        <Input page="yeni-sifre-belirle" name="password" />
        <p className="text-sm font-normal text-grayy text-center max-w-[376px]">
          En az{" "}
          <span className="font-semibold">8 karakter, bir büyük harf</span> ve{" "}
          <span className="font-semibold">rakam</span> içermelidir.
        </p>
        <Button page="yeni-sifre-belirle" loading={loading} />
        {error && <p className="text-red-500 text-sm text-center">{error}</p>}
      </form>
      {showAlert && (
        <YesilAlert
          message={alertMessage}
          onConfirm={handleAlertConfirm}
          onClose={handleAlertClose}
          hideButtons={true}
        />
      )}
    </div>
  );
};

export default YeniSifre;
